import StoreNotificationsServices from '@/services/storeNotifications'
import ArrayUtils from '@/utils/arrayUtils'

export default
{
    namespaced: true,
    
    state:
    {
        storeList: []
    },

    getters:
    {
        getStoreById: state => id =>
        {
            return state.storeList.find(s => s.id == id)
        }
    },

    mutations:
    {
        setStoreList (state, stores)
        {
            state.storeList = stores
        },

        updateStoreList (state, stores) 
        {
            var merged = ArrayUtils.mergeArrays(state.storeList, stores, (a, b) => a.id == b.id)

            merged = merged.sort((a, b) =>
            {
                if (a.isUncreated) return -Infinity

                return a.id - b.id
            })

            state.storeList = merged
        }
    },

    actions:
    {
        removeStoreById ({ getters, state }, id)
        {
            let store = state.storeList.find(s => s.id == id)
            
            if (!store) return
            
            const stores = state.storeList
            stores.splice(stores.indexOf(store), 1)

            state.storeList = stores
        },

        async fetchStoreNotificationQuota (context, { cityId, storeId, token })
        {
            const s = { id: storeId }

            s.notificationQuota = await StoreNotificationsServices.fetchNotificationQuota(storeId, cityId, token)

            context.commit('updateStoreList', [s])
        },
    }
}


// WEBPACK FOOTER //
// ./src/stores/stores.js